import ErrorMessage from '../../../Elements/ErrorMessage';
import CountryService from '../../../Services/CountryService';
import EvaluatorService from '../../../Services/EvaluatorService';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import CountrySearchParams from '../../Countries/CountryAdmin/CountrySearchParams';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';

const SUCCESS_MESSAGE =
  'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

function confirmAndExecute(action) {
  ErrorMessage.SetApprove('You will generate the report.', action);
}

// showPanel: (panel) => void — supplied by ReportAdmin to open the matching wizard panel (setState on shownPanel).
export default function buildReportAdminSections(showPanel) {
  return [
    {
      title: 'Finance & Accounting',
      cards: [
        {
          title: 'AR Ageing Report',
          description: 'Export an Excel workbook of the accounts-receivable ageing report.',
          fmt: 'XLSX',
          iconName: 'fa-solid fa-clock',
          roleKey: 'report_arageingreport_run',
          onClick: () => showPanel(ShownPanelsEnum.ARAgeingReport),
        },
        {
          title: 'QBO Invoice Export',
          description: 'Export the CSV file of QuickBooks Online invoices.',
          fmt: 'CSV',
          iconName: 'fa-solid fa-file-lines',
          roleKey: 'report_qboinvoice_run',
          onClick: () => showPanel(ShownPanelsEnum.QboInvoiceExport),
        },
        {
          title: 'QBO Credit Memo Export',
          description: 'Export the CSV file of QuickBooks Online credit memos.',
          fmt: 'CSV',
          iconName: 'fa-solid fa-file',
          roleKey: 'report_qbocreditmemo_run',
          onClick: () => showPanel(ShownPanelsEnum.QboCreditMemoExport),
        },
        {
          title: 'SAP Reconciliation Export',
          description: 'Export the CSV file of the SAP reconciliation.',
          fmt: 'CSV',
          iconName: 'fa-solid fa-server',
          roleKey: 'report_sapreconciliation_run',
          onClick: () => showPanel(ShownPanelsEnum.ReconcileExport),
        },
        {
          title: 'Unapplied Prepayment Report',
          description: 'Export an Excel workbook of unapplied prepayment data.',
          fmt: 'XLSX',
          iconName: 'fa-solid fa-coins',
          roleKey: 'report_unappliedprepayment_run',
          onClick: () => showPanel(ShownPanelsEnum.UnappliedPrepaymentReport),
        },
        {
          title: 'TP Revenue by Revenue Period',
          description: 'Export an Excel workbook of third-party revenue broken down by revenue period.',
          fmt: 'XLSX',
          iconName: 'fa-solid fa-chart-column',
          roleKey: 'report_tprevenuebyrevenueperiod_run',
          onClick: () => showPanel(ShownPanelsEnum.TpRevenueByRevenuePeriodReport),
        },
      ],
    },
    {
      title: 'Evaluators & Payments',
      cards: [
        {
          title: 'Approved Evaluator Payment Export',
          description: 'Export an Excel workbook of approved evaluator payments.',
          fmt: 'XLSX',
          iconName: 'fa-solid fa-coins',
          roleKey: 'report_evaluatorpaymentsexport_run',
          onClick: () => showPanel(ShownPanelsEnum.EvaluatorPaymentsExport),
        },
        {
          title: 'Tipalti Export',
          description: "Export the CSV file of the evaluators' Tipalti payment data.",
          fmt: 'CSV',
          iconName: 'fa-solid fa-users',
          roleKey: 'tipaltidownloadbutton',
          onClick: () =>
            confirmAndExecute(() => {
              EvaluatorService.GetTipaltiExportFile().catch(() => ErrorMessage.SetErrorMessage('RA77'));
              ErrorMessage.SetSuccessWithWait(SUCCESS_MESSAGE);
            }),
        },
        {
          title: 'Evaluator Count Report',
          description:
            'Evaluator counts on Apollo by level (Office, Country, State, City) for active, self-deactivated and total database size.',
          fmt: 'REPORT',
          kind: 'report',
          iconName: 'fa-solid fa-users',
          roleKey: 'report_evaluatorcountreport_run',
          onClick: () => showPanel(ShownPanelsEnum.EvaluatorCountReport),
        },
        {
          title: 'Evaluator Lead Report',
          description: 'Run a lead / registration report to view evaluator lead-conversion KPIs.',
          fmt: 'REPORT',
          kind: 'report',
          iconName: 'fa-solid fa-chart-line',
          roleKey: 'report_evaluatorleadreport_run',
          onClick: () => showPanel(ShownPanelsEnum.EvaluatorLeadReport),
        },
      ],
    },
    {
      title: 'Data Exports',
      cards: [
        {
          title: 'Excel Data Export',
          description: 'Export an Excel data workbook for clients.',
          fmt: 'XLSX',
          iconName: 'fa-solid fa-table-cells',
          roleKey: 'exceldataexport',
          onClick: () => showPanel(ShownPanelsEnum.ExcelDataExport),
        },
        {
          title: 'Country Export',
          description: 'Export the CSV file of the countries reference list.',
          fmt: 'CSV',
          iconName: 'fa-solid fa-map',
          roleKey: '',
          onClick: () =>
            confirmAndExecute(() => {
              CountryService.DownloadCountryListDetailsInExcel(new CountrySearchParams()).catch(() =>
                ErrorMessage.SetErrorMessage('RA88')
              );
              ErrorMessage.SetSuccessWithWait(SUCCESS_MESSAGE);
            }),
        },
        {
          title: 'Referral Shop Export',
          description: 'Create a referral-shop Excel export.',
          fmt: 'XLSX',
          iconName: 'fa-solid fa-link',
          note: 'Generated file downloadable for 3 days',
          roleKey: 'report_referralshopexport_run',
          onClick: () =>
            confirmAndExecute(() => {
              ReportRunnerService.RequestReport().catch(() => ErrorMessage.SetErrorMessage('RA66'));
              ErrorMessage.SetSuccessWithWait(SUCCESS_MESSAGE);
            }),
        },
      ],
    },
  ];
}
